import React from 'react';

import {
  serializeSpendPointsPayload,
  serializeSpendPointsPreviewPayload,
  spendPointsPayloadDownloadFilename,
} from '~/utils/societePayloadBuilder/spendPoints/buildPayload';
import { createDefaultSpendPointsState } from '~/utils/societePayloadBuilder/spendPoints/defaults';
import { hasSpendPointsProgress } from '~/utils/societePayloadBuilder/spendPoints/hasProgress';
import { parseSpendPointsPayload } from '~/utils/societePayloadBuilder/spendPoints/parsePayload';
import type { SpendPointsPayloadBuilderState } from '~/utils/societePayloadBuilder/spendPoints/types';
import { validateSpendPointsPayload } from '~/utils/societePayloadBuilder/spendPoints/validatePayload';

import PayloadBuilderJsonPreview from '../JsonPreview';
import StandalonePayloadActions from '../StandalonePayloadActions';
import StandalonePayloadBuilderPage from '../StandalonePayloadBuilderPage';

import SpendPointsPayloadBuilderForm from './SpendPointsPayloadBuilderForm';

interface SpendPointsPayloadBuilderPageProps {
  onProgressChange?: (hasProgress: boolean) => void;
}

export default function SpendPointsPayloadBuilderPage({ onProgressChange }: SpendPointsPayloadBuilderPageProps) {
  return (
    <StandalonePayloadBuilderPage<SpendPointsPayloadBuilderState>
      onProgressChange={onProgressChange}
      createDefaultState={createDefaultSpendPointsState}
      hasProgress={hasSpendPointsProgress}
      parsePayload={parseSpendPointsPayload}
      validate={validateSpendPointsPayload}
      renderActions={(state, isValid, fullWidth) => (
        <StandalonePayloadActions
          state={state}
          isValid={isValid}
          fullWidth={fullWidth}
          serialize={serializeSpendPointsPayload}
          getFilename={spendPointsPayloadDownloadFilename}
          payloadName="Spend Points"
        />
      )}
      renderForm={(props) => <SpendPointsPayloadBuilderForm {...props} />}
      renderPreview={(state, borderSoft, maxHeight) => (
        <PayloadBuilderJsonPreview
          state={state}
          serialize={serializeSpendPointsPreviewPayload}
          borderSoft={borderSoft}
          maxHeight={maxHeight}
        />
      )}
    />
  );
}
